import { render, staticRenderFns } from "./view6.vue?vue&type=template&id=655b4042&scoped=true"
import script from "./view6.vue?vue&type=script&lang=js"
export * from "./view6.vue?vue&type=script&lang=js"
import style0 from "./view6.vue?vue&type=style&index=0&id=655b4042&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655b4042",
  null
  
)

export default component.exports